// A page break is a placeholder in My Games' `favorites` array - stored
// alongside real numeric game ids, but as a string like "-1-", "-2-" so it
// can never collide with one. The number increments per break so several can
// exist and each is still individually addressable (move/delete, and the
// reveal state below).
const PAGE_BREAK_PATTERN = /^-(\d+)-$/;

export const isPageBreakId = (id) => typeof id === 'string' && PAGE_BREAK_PATTERN.test(id);

// Only real game ids count toward "has this person favorited anything" -
// used wherever `favorites.length` used to mean that (D53's ladder state 1,
// the Editor's Picks explainer) so a page break alone doesn't count as a
// playlist.
export const realFavoritesCount = (favorites) => favorites.filter((id) => !isPageBreakId(id)).length;

// Next unused sentinel, scanning existing ones rather than counting them, so
// deleting break 2 of 3 and adding a new one doesn't collide with break 3.
export const nextPageBreakId = (favorites) => {
  const highest = favorites.reduce((max, id) => {
    const match = typeof id === 'string' && id.match(PAGE_BREAK_PATTERN);
    return match ? Math.max(max, Number(match[1])) : max;
  }, 0);
  return `-${highest + 1}-`;
};
